module.exports = "query GetCardCategory($id: ID!) {\n  cardCategory(id: $id) {\n    ...CardCategoryFragment\n  }\n}\n"